import React from 'react';
import { BookOpenIcon, TrendingUpIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function SolutionSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5 relative overflow-hidden" data-id="element-121">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-primary/5 rounded-full blur-3xl pointer-events-none" data-id="element-122"></div>

      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-123">
        <div className="space-y-8 text-gray-200" data-id="element-124">
          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-125">
            Mi nombre es{' '}
            <span className="text-white font-bold" data-id="element-126">[Tu Nombre]</span> y después
            de años de estudiar directamente las publicaciones oficiales del
            IRS, descubrí algo que cambió mi vida:
          </p>

          <div className="bg-navy-dark p-6 md:p-8 rounded-xl border-l-4 border-gold-primary shadow-lg" data-id="element-127">
            <p className="text-xl md:text-2xl font-bold text-gold-light italic" data-id="element-128">
              "El IRS publica las reglas, pero no te enseña a usarlas a tu
              favor."
            </p>
          </div>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-129">
            Desarrollé un sistema simple que llamo{' '}
            <span className="text-gold-primary font-bold" data-id="element-130">
              "El Método del Contribuyente Inteligente"
            </span>
            . No es magia, es pura ley tributaria aplicada con estrategia.
          </p>

          <div className="flex items-center gap-4 bg-green-900/20 p-6 rounded-xl border border-green-500/20" data-id="element-131">
            <TrendingUpIcon className="w-12 h-12 text-green-400 flex-shrink-0" data-id="element-132" />
            <p className="text-xl md:text-2xl font-medium text-white" data-id="element-133">
              Logré que mi propio reembolso saltara de{' '}
              <span className="text-red-400 line-through decoration-2" data-id="element-134">
                $3,500
              </span>{' '}
              a <span className="text-green-400 font-bold" data-id="element-135">$8,500</span>{' '}
              aplicando exactamente lo que estoy a punto de revelarte.
            </p>
          </div>
        </div>
      </div>
    </section>;
}